'use strict';

import React from 'react';
import Button from '@material-ui/core/Button';
import bemit from 'Functions/bemit';
import Image from 'Pure/Image';
import Link from 'Pure/Link';
import { URL } from 'Shared/Routes';
import { coworking_place_types } from 'Shared/options';
const config = [{
  title: coworking_place_types.find(opt => opt.value === 'c_open_coworking_space')?.front_label || '',
  description: /*#__PURE__*/React.createElement("p", {
    className: "c-card__text"
  }, "Co-working ouvert \xE0 tous", /*#__PURE__*/React.createElement("br", null), "Toute la journ\xE9e", /*#__PURE__*/React.createElement("br", null), "Avec ou sans r\xE9servation", /*#__PURE__*/React.createElement("em", {
    className: "c-card__special-txt"
  }, "Sous r\xE9serve de consommation et de places")),
  img: '/espace_lib.jpg',
  alt: 'Un espace de travail ouvert myWO Lib'
}, {
  title: coworking_place_types.find(opt => opt.value === 'a_calm_coworking_space')?.front_label || '',
  description: /*#__PURE__*/React.createElement("p", {
    className: "c-card__text"
  }, "Co-working calme et isol\xE9", /*#__PURE__*/React.createElement("br", null), "\xC0 l'heure / Demi-journ\xE9e / Journ\xE9e", /*#__PURE__*/React.createElement("br", null), "Payant et sur r\xE9servation"),
  img: '/espace_lounge.jpg',
  alt: 'Un espace de travail calme et isolé myWO Lounge'
}, {
  title: coworking_place_types.find(opt => opt.value === 'b_seminar')?.front_label || '',
  description: /*#__PURE__*/React.createElement("p", {
    className: "c-card__text"
  }, "S\xE9minaires et journ\xE9es d'\xE9tude", /*#__PURE__*/React.createElement("br", null), "Demi-journ\xE9e / Journ\xE9e", /*#__PURE__*/React.createElement("br", null), "Payant et sur r\xE9servation"),
  img: '/espace_meeting.jpg',
  alt: 'Un espace de réunion ou séminaire myWO Meeting'
}];
export default function SpacesTypesBlock({
  ...props
}) {
  const modifiers = [].concat(props.bemit || []);
  const item_classes = bemit('c-card', modifiers);
  const items = config.map(function (infos, i) {
    const img_src = '/images/front' + infos.img;
    const x2_src = '/images/front/2x' + infos.img;
    const output = /*#__PURE__*/React.createElement("div", {
      className: item_classes,
      key: infos.img + i
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-card__img-container"
    }, /*#__PURE__*/React.createElement(Image, {
      src: img_src,
      className: "c-card__img",
      alt: infos.alt
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-card__content"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "c-card__title"
    }, infos.title), infos.description, /*#__PURE__*/React.createElement("div", {
      className: "c-card__link-container"
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['front', 'blue', 'spaces-types-block']),
      href: URL('ConceptPage'),
      component: Link
    }, "En savoir plus"))));
    return output;
  });
  const output = /*#__PURE__*/React.createElement("section", {
    className: bemit('o-section', modifiers.concat(['spaces-types-block']))
  }, /*#__PURE__*/React.createElement("header", {
    className: "o-section__header"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "c-title"
  }, "Nos 3 types d'espaces")), /*#__PURE__*/React.createElement("div", {
    className: "o-section__grid"
  }, items, /*#__PURE__*/React.createElement("div", {
    className: "c-card c-card--home"
  }), /*#__PURE__*/React.createElement("div", {
    className: "c-card c-card--home"
  }), /*#__PURE__*/React.createElement("div", {
    className: "c-card c-card--home"
  })));
  return output;
}
